import { Middleware } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';

import { ReduxStore, bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import { MiddlewareManager } from '@makemydeal/dr-activities-recent-deals';
import type { DashStoreMiddlewareApi } from '@makemydeal/dr-dash-store/types/appState';

import { configureRecentDeals } from './config';
import { StateTree } from '@makemydeal/dr-dash-types';

// keep a cached version of the middleware once we're able to build it.
// exported to support testing
export let cachedRecentDealsMiddlewareMgr: MiddlewareManager | undefined;

// needed for testing
export const recentDealsMiddlewareClearCache = () => (cachedRecentDealsMiddlewareMgr = undefined);

export const recentDealsMiddleware: Middleware<unknown, StateTree> =
    (store: ReduxStore<any>) => (next: any) => (action: AnyFSA) => {
        switch (action.type) {
            case bootstrapActionTypes.BOOTSTRAP_SUCCESS: {
                cachedRecentDealsMiddlewareMgr = configureRecentDeals();

                break;
            }
        }

        if (cachedRecentDealsMiddlewareMgr) {
            cachedRecentDealsMiddlewareMgr.middleware(store as DashStoreMiddlewareApi)(next)(action);
        } else {
            next(action);
        }
    };
